<template>
  <v-container>
    <v-row>
      <v-card width="300" class="ml-5" v-if="!$store.state.auth.user.twofa_active">
        <div class="pa-3">
          <v-img
            class="white--text align-end"
            width="300px"
            height="300px"
            :src="qr"
          >
            <v-card-title></v-card-title>
          </v-img>

          <v-text-field
            v-model="code"
            placeholder="Enable 2FA"
            hide-details
            style="width: 300px"
            class="mb-3 mt-3"
          ></v-text-field>

          <v-btn small color="info" @click="enable">Enable</v-btn>
        </div>
      </v-card>
      <v-card width="300" class="ml-5 text-center">
        <div class="pa-3">
          <v-card-title>You can download Google Authenticator</v-card-title>

          <a :href="googleStoreUrl" target="_blank" style="display: inline-block; margin-top: 90px;">
            <v-img width="250" height="74" :src="googleStoreImg">
              <v-card-title></v-card-title>
            </v-img>
          </a>

          <a :href="appStoreUrl" target="_blank" style="display: inline-block" class="mt-4">
            <v-img width="250" height="74" :src="appStoreImg">
              <v-card-title></v-card-title>
            </v-img>
          </a>
        </div>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import { API } from '@/utils/api'

  export default {
    data: () => ({
      googleStoreImg: BASE_URL + '/img/google-play-badge250.png',
      appStoreImg: BASE_URL + '/img/appstore-badge250.png',
      appStoreUrl: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
      googleStoreUrl: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=ru',
      qr: '',
      code: null,
    }),

    mounted () {
      API.call('/two_fa/get_qr.json').then(resp => {
        this.qr = resp.qr
      })
    },

    methods: {
      enable () {
        API.call('/two_fa/enable.json', { code: this.code }).then(resp => {
          this.$notification.show = true
          this.$notification.message = resp.data.result ? '2FA activated!' : 'Try again, code doesn\'t match!'
          this.$notification.type = resp.data.result ? 'success' : 'warning'

          if (resp.data.result) {
            this.$store.dispatch('auth/checkSession', {})
          }
        }).catch(e => {
        })
      }
    }

  }
</script>
